import { render } from "./PhoneRequests.vue?vue&type=template&id=41019bc5&ts=true"
import script from "./PhoneRequests.vue?vue&type=script&lang=ts"
export * from "./PhoneRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__